var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderWaitingForConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 7.5,
    fill: "#FFFBF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1336_20177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8015 6.2742L16.8015 6.27419L16.801 6.26832C16.7914 6.15789 16.8058 6.04651 16.8438 5.9409C16.8817 5.83524 16.9427 5.73693 17.0238 5.65262C17.105 5.56825 17.2047 5.49976 17.3171 5.45241C17.4296 5.40505 17.5518 5.38015 17.6759 5.37977L17.6796 5.37972C18.1426 5.37367 18.6124 5.37367 19.079 5.37838C19.7028 5.38612 20.0827 5.85599 19.9867 6.40163L19.9867 6.40169C19.9393 6.67172 19.8909 6.94184 19.8425 7.21265C19.794 7.48326 19.7455 7.75455 19.6978 8.02595L19.6976 8.02678C19.631 8.41106 19.9173 8.7148 20.2299 8.77733C20.2589 8.78315 20.2878 8.78889 20.3164 8.79459C20.5158 8.83434 20.7041 8.87187 20.8908 8.91646C21.0162 8.94642 21.1389 8.97889 21.2651 9.01355C21.2652 9.01357 21.2652 9.01359 21.2653 9.01361C21.2661 9.01458 21.2681 9.01727 21.27 9.02237C21.275 9.03645 21.2733 9.05195 21.2664 9.06346C20.6626 10.0691 20.4478 11.1539 20.6541 12.3161C20.8346 13.3397 21.3581 14.2768 22.142 14.9879C23.4917 16.2429 25.9212 16.9041 28.2131 15.6545C28.2185 15.6515 28.2239 15.6501 28.229 15.6497C28.2327 15.6494 28.2359 15.6497 28.2384 15.6502C28.5458 16.6762 28.6907 17.7401 28.6682 18.8068H8.1512C8.09284 16.4061 8.7768 14.2425 10.3509 12.3471C11.9297 10.4459 13.9744 9.2798 16.4699 8.79325C16.8671 8.7158 17.1462 8.33563 17.0751 7.92277C17.0136 7.56563 16.9533 7.21466 16.8937 6.86342L16.524 6.92611L16.8938 6.86419C16.8821 6.79409 16.8703 6.72997 16.8593 6.6696C16.8331 6.52689 16.8108 6.40505 16.8015 6.2742Z",
    fill: "#FFFBF5",
    stroke: "url(#paint0_linear_1336_20177)",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4238 20.9546H30.1835C30.6971 20.9546 30.8164 21.0941 30.8171 21.6921C30.8171 22.0084 30.8129 22.3256 30.8171 22.6419C30.8233 22.7527 30.8029 22.8634 30.7585 22.9612C30.714 23.059 30.6472 23.14 30.5657 23.195C30.0285 23.59 29.4942 23.9943 28.9542 24.3791C28.8391 24.4559 28.7092 24.4961 28.5771 24.4958C21.7978 24.5015 15.018 24.5015 8.23775 24.4958C8.09764 24.4925 7.96061 24.4465 7.83988 24.3622C7.32058 23.9943 6.81342 23.601 6.29625 23.2297C6.0941 23.0842 5.99196 22.8956 6.00053 22.6098C6.01053 22.2613 6.00053 21.9128 6.00053 21.5652C6.00481 21.1356 6.15696 20.9563 6.52698 20.9563C7.97893 20.9563 9.43137 20.9563 10.8843 20.9563L18.4238 20.9546Z",
    fill: "url(#paint1_linear_1336_20177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6074 14.3058C28.6876 14.3058 30.3739 12.6195 30.3739 10.5394C30.3739 8.45924 28.6876 6.77295 26.6074 6.77295C24.5273 6.77295 22.841 8.45924 22.841 10.5394C22.841 12.6195 24.5273 14.3058 26.6074 14.3058Z",
    fill: "url(#paint2_linear_1336_20177)",
    stroke: "url(#paint3_linear_1336_20177)",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6075 8.38721V10.5395L27.6836 11.6156",
    fill: "url(#paint4_linear_1336_20177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6075 8.38721V10.5395L27.6836 11.6156",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1336_20177",
    x: 5.25003,
    y: 4.25,
    width: 27.8182,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75,
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.239216 0 0 0 0 0.682353 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1336_20177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1336_20177",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1336_20177",
    x1: 6.8864,
    y1: 7.65909,
    x2: 28.1591,
    y2: 19.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1336_20177",
    x1: -0.204514,
    y1: 20.9546,
    x2: 29.0455,
    y2: 24.9432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1336_20177",
    x1: 23.2842,
    y1: 6.77295,
    x2: 27.716,
    y2: 9.87522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1336_20177",
    x1: 26.6074,
    y1: 6.77295,
    x2: 26.6074,
    y2: 14.3058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1336_20177",
    x1: 26.6708,
    y1: 8.38721,
    x2: 27.5654,
    y2: 8.59596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderWaitingForConfirmation);
export default __webpack_public_path__ + "static/media/order-waiting-for-confirmation.a7c6d076224bb4a815152e8ff79afbcb.svg";
export { ForwardRef as ReactComponent };